import { useContext } from 'react';
import { Icon, IconButton } from '@zillow/constellation-10';
import { IconStar0Percent, IconStar100Percent } from '@zillow/constellation-icons';
import { LeadManagementContext } from '../../contexts/LeadManagementContextProvider';
import { AppContext } from '../../contexts/AppContextProvider';
import useLeadManagementActions from '../../hooks/useLeadManagementActions';

type StarIconButtonProps = {
  conversationId: string;
  isConversationBlockedByZillow: boolean;
  isFavorite: boolean;
  hasMargin?: boolean;
};

export default function StarIconButton({
  conversationId,
  isConversationBlockedByZillow,
  isFavorite,
  hasMargin = false,
}: StarIconButtonProps) {
  const { isImpersonator } = useContext(AppContext);
  const { isArchivedFolder, isReportedFolder } = useContext(LeadManagementContext);
  const { handleFavoriteUnfavoriteClick } = useLeadManagementActions({ conversationId });

  const isStarIconDisabled = isImpersonator || isArchivedFolder || isReportedFolder || isConversationBlockedByZillow;

  const handleStarLead = (isFavorite: boolean) => {
    return handleFavoriteUnfavoriteClick(isFavorite);
  };

  return (
    <IconButton
      disabled={isStarIconDisabled}
      emphasis="bare"
      shape="circle"
      tone="neutral"
      icon={
        isFavorite ? (
          <Icon css={{ color: 'bg.accent.yellow.soft' }} render={<IconStar100Percent />} />
        ) : (
          <Icon render={<IconStar0Percent />} />
        )
      }
      title="star"
      aria-pressed={isFavorite}
      onClick={() => handleStarLead(isFavorite)}
      css={{ marginRight: hasMargin ? 'tighter' : 0 }}
    />
  );
}
